// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1195":"00256724","2970":"d45aef85","5932":"59b77554","7424":"59b77554"}[chunkId] + ".chunk.css";
};